import NextImage from 'next/image';
import type { CSSProperties, HTMLAttributeReferrerPolicy, ImgHTMLAttributes, ReactElement, ReactEventHandler, } from 'react';
import { motion } from 'framer-motion';
import type { TargetAndTransition, Transition } from 'framer-motion';
import { CIMAGE_BORDER_RADIUS_INHERIT } from './cimage-constants';
import { buildStaticMotionStyle, isSvgSource, type ImageDimensionModel } from './cimage-model';
import type { CimageObjectFit } from './cimage-constants';
interface CimageStaticRendererProps {
    alt: string;
    ariaHidden?: boolean;
    dimensionModel: ImageDimensionModel;
    draggable?: boolean;
    imageAnimate: false | TargetAndTransition;
    imageExit: TargetAndTransition;
    imageInitial: false | TargetAndTransition;
    imageStyle: CSSProperties;
    objectFit: CimageObjectFit;
    onError: ReactEventHandler<HTMLImageElement>;
    onLoad: ReactEventHandler<HTMLImageElement>;
    priority?: boolean;
    referrerPolicy?: HTMLAttributeReferrerPolicy;
    renderedSrc: string;
    setImageRef: (img: HTMLImageElement | null) => void;
    sizes?: string;
    title?: string;
    transition: Transition;
    unoptimized?: boolean;
}
export function CimageStaticRenderer({ alt, ariaHidden, dimensionModel, draggable, imageAnimate, imageExit, imageInitial, imageStyle, objectFit, onError, onLoad, priority, renderedSrc, setImageRef, sizes, title, transition, unoptimized, }: CimageStaticRendererProps): ReactElement {
    const imageElement = dimensionModel.hasNumericDims ? (<NextImage ref={setImageRef} src={renderedSrc} alt={alt} title={title} width={dimensionModel.derivedWidth} height={dimensionModel.derivedHeight} priority={priority} sizes={sizes} unoptimized={unoptimized ?? isSvgSource(renderedSrc)} draggable={draggable} aria-hidden={ariaHidden} onLoad={onLoad} onError={onError} style={imageStyle}/>) : (<NextImage ref={setImageRef} src={renderedSrc} alt={alt} title={title} fill={true} priority={priority} sizes={sizes} unoptimized={unoptimized ?? isSvgSource(renderedSrc)} draggable={draggable} aria-hidden={ariaHidden} onLoad={onLoad} onError={onError} style={{
            objectFit,
            borderRadius: CIMAGE_BORDER_RADIUS_INHERIT,
        }}/>);
    return (
    <motion.span initial={imageInitial} animate={imageAnimate} exit={imageExit} transition={transition} style={buildStaticMotionStyle({
            hasNumericDims: dimensionModel.hasNumericDims,
        })}>
      {imageElement}
    </motion.span>
    );
}
